import { PlusOutlined, UploadOutlined } from '@ant-design/icons';
import { Button, Drawer, Form, Input, Space, Upload, message } from 'antd';
import { CONTENT_SPAN, LABEL_SPAN } from 'constants/table';
import { UploadList } from 'pages/Clients/AllClients/ClientDetailForm/style';
import { useEffect, useState } from 'react';
import { ClientsService } from 'services/ClientsService';
import { DiagnosticService } from 'services/DiagnosticService';
import { FormWrapper } from 'ui/FormWrapper';
import { normFile, toBase64, urlToFile } from 'utils/files';
import {
  iinRule,
  onlyNumberRule,
  requiredRule,
} from 'utils/forms/validationRules';

function DiagnosticForm({ visible, closeDrawer, clientId, openDrawer }) {
  const [form] = Form.useForm();
  const [clientDetail, setClientDetail] = useState(null);
  const [loading, setLoading] = useState(false);

  const convertDigitalSignsToBase64 = async (file) => {
    try {
      const digitalSignBase64 = await toBase64(file);

      return digitalSignBase64;
    } catch (err) {
      message.error('Произошла ошибка, проверьте файл ЭЦП');
    }
  };

  const prePopulateForm = async () => {
    const { data, cds } = clientDetail;

    const { AUTH } = cds;

    const authFile = await urlToFile(
      AUTH?.data,
      `AUTH_${data?.bin_iin}.p12`,
      'application/x-pkcs12'
    );

    form.setFieldsValue({
      data_auth: authFile ? [authFile] : undefined,
      auth_password: AUTH?.password,
      iin: data?.bin_iin,
    });
  };

  const onSubmit = async (values) => {
    const payload = {
      ...values,
      data_auth: null,
    };

    if (clientDetail) {
      const { cds } = clientDetail;
      const { AUTH } = cds;

      const { data_auth } = values;

      if (!data_auth || !data_auth?.length) {
        payload.auth_ds = undefined;
      } else if (
        data_auth &&
        data_auth?.length &&
        !data_auth[0]?.originFileObj
      ) {
        payload.auth_ds = AUTH.data;
      } else {
        const authFile = await convertDigitalSignsToBase64(
          data_auth[0]?.originFileObj
        );
        payload.auth_ds = authFile;
      }
    } else {
      const { data_auth } = values;

      if (!data_auth || !data_auth?.length) {
        payload.auth_ds = undefined;
      } else {
        const authFile = await convertDigitalSignsToBase64(
          data_auth[0]?.originFileObj
        );
        payload.auth_ds = authFile;
      }
    }
    const close = message.loading('Загрузка диагностики', 1000);
    try {
      setLoading(true);
      const res = await DiagnosticService.createDiagnostic(payload);
      if (res) {
        openDrawer(res);
        setLoading(false);
        close();
      }
    } catch (error) {
      message.error('Не удалось создать диагностику');
      setLoading(false);
      close();
    }
  };

  useEffect(() => {
    if (clientId) {
      fetchClientDetail(clientId);
    }
  }, [clientId]);

  useEffect(() => {
    if (clientDetail) {
      prePopulateForm();
    }
  }, [clientDetail, clientId]);

  const fetchClientDetail = async (id) => {
    try {
      const details = await ClientsService.getClientDetail(id);

      setClientDetail(details);
    } catch (err) {
      message.error('Не удалось загрузить ЭЦП');
    }
  };

  return (
    <Drawer width="60%" visible={visible} onClose={closeDrawer}>
      <FormWrapper>
        <Form
          onFinish={onSubmit}
          form={form}
          layout="horizontal"
          labelCol={{
            span: LABEL_SPAN,
          }}
          wrapperCol={{ span: CONTENT_SPAN }}
          labelAlign="right"
        >
          <Form.Item
            name="iin"
            label="ИИН/БИН"
            rules={[onlyNumberRule, iinRule]}
            required
          >
            <Input showCount allowClear maxLength={12} placeholder="ИИН/БИН" />
          </Form.Item>

          <Form.Item required label="AUTH">
            <Space direction="horizontal" align="baseline">
              <Form.Item noStyle>
                <UploadList>
                  <Form.Item
                    name="data_auth"
                    valuePropName="fileList"
                    getValueFromEvent={normFile}
                    noStyle
                    style={{ alignSelf: 'baseline' }}
                    rules={[requiredRule]}
                  >
                    <Upload
                      maxCount={1}
                      accept=".p12"
                      beforeUpload={() => false}
                      onRemove={() => {
                        form.setFieldsValue({
                          password_auth: undefined,
                        });
                      }}
                    >
                      <Button style={{ width: 200 }} icon={<UploadOutlined />}>
                        Прикрепить ЭЦП
                      </Button>
                    </Upload>
                  </Form.Item>
                </UploadList>
              </Form.Item>

              <Form.Item
                noStyle
                name="auth_password"
                rules={[requiredRule]}
                dependencies={['data_auth']}
              >
                <Input placeholder="Введите пароль" style={{ width: 200 }} />
              </Form.Item>
            </Space>
          </Form.Item>

          <Form.Item wrapperCol={{ offset: CONTENT_SPAN }}>
            <Button
              disabled={loading}
              type="primary"
              htmlType="submit"
              icon={<PlusOutlined />}
            >
              Получить Диагностику
            </Button>
          </Form.Item>
        </Form>
      </FormWrapper>
    </Drawer>
  );
}

export { DiagnosticForm };
